import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/forgot-password/set/page";

export const Route = createFileRoute("/auth/forgot-password/set")({
  component: Page,
});
